import {
  AUTH_USER,
  UNAUTH_USER,
} from '../actions/types/authTypes';

const INITIAL_STATE = {
  user: null,
};

export default (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case AUTH_USER:
      return { user: action.result.user };
    case UNAUTH_USER:
      return INITIAL_STATE;
    default: return state;
  }

};



// WEBPACK FOOTER //
// ./src/redux/reducers/authReducer.js